import { type NotificationDestination, NotificationTarget } from "@upsquad/shared";
import { ADMIN_ROUTES } from "@/src/admin/constants/admin-routes";
import { EVENT_ROUTES } from "@/src/event/constants/event-routes";
import { GROUP_ROUTES } from "@/src/group/constants/group-routes";
import { MEETING_ROUTES } from "@/src/meeting/constants/meeting-routes";
import { MEMBER_ROUTES } from "@/src/member/constants/member-routes";
import { POST_ROUTES } from "@/src/post/constants/post-routes";

export function getNotificationUrl(destination: NotificationDestination): string {
	switch (destination.target) {
		case NotificationTarget.FEED:
			return POST_ROUTES.FEED;
		case NotificationTarget.MEETING_DETAIL:
			return MEETING_ROUTES.DETAIL.replace(":meetingId", destination.meetingId);
		case NotificationTarget.MEETING_LIST:
			return MEETING_ROUTES.LIST;
		case NotificationTarget.MEMBER_LIST:
			return MEMBER_ROUTES.LIST;
		case NotificationTarget.EVENT_LIST:
			return EVENT_ROUTES.LIST;
		case NotificationTarget.GROUP_LIST:
			return GROUP_ROUTES.GROUPS;
		case NotificationTarget.ADMIN_GROUP_LIST:
			return ADMIN_ROUTES.GROUPS;
	}
}
